<div class="stops-history-container">
  <!-- Estado vacío -->
  <div *ngIf="isEmpty" class="empty-state-container">
    <div class="empty-state">
      <div class="empty-icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            fill="#9CA3AF"
          />
        </svg>
      </div>
      <h3 class="empty-title">Sin paradas registradas</h3>
      <p class="empty-message">{{ emptyMessage }}</p>
      <p class="suggestion-message">{{ suggestionMessage }}</p>
      <div class="action-buttons">
        <button
          class="btn btn-outline-primary btn-sm"
          (click)="onRedirectTo('frames')"
        >
          <i class="fas fa-map-marker-alt"></i> Ver Frames
        </button>
        <button
          class="btn btn-outline-success btn-sm"
          (click)="onRedirectTo('events')"
        >
          <i class="fas fa-exclamation-triangle"></i> Ver Eventos
        </button>
      </div>
    </div>
  </div>

  <!-- Lista con virtual scrolling -->
  <cdk-virtual-scroll-viewport
    *ngIf="!isEmpty"
    class="virtual-scroll-viewport"
    [itemSize]="itemSize"
  >
    <aside-history-card
      *cdkVirtualFor="let stop of stops; trackBy: trackByStopId"
      [data]="stop"
      [isSelected]="isCardSelected(stop.id, stop.type, stop.variant)"
      (selectCard)="onSelectCard($event)"
    ></aside-history-card>
  </cdk-virtual-scroll-viewport>
</div>
